import React, {PureComponent} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import ColorGenerator from "../../../helpers/color-generator";
import colors from "../../../util/colors";
import _ from 'lodash'
import memoizeOne from "memoize-one";
import withVfRouting from "../../../util/withVFRouting";
import log from "../../../util/log";
import c from "../../../util/const";

const MEDIUM_SIZE_WIDTH = 48;

class UserBadge extends PureComponent {

  getCharString = memoizeOne((guest) => {
    if(!guest.first_name || !guest.last_name){
      return '';
    }
    let charString = guest.first_name[0] + guest.last_name[0];
    return charString.toUpperCase();
  })

  getGuestUid = memoizeOne((guest) => {
    if(!guest.first_name || !guest.last_name){
      return '';
    }
    return guest.guest_uid || guest.uid || null;
  })

  getUserColor = memoizeOne((guest_uid) => {
    return ColorGenerator.generateColorFromId(guest_uid);
  })

  getBadgeStyle = memoizeOne((small, large, isVFBlackUser) => {
    let borderStyle = {
      border: `2px solid transparent`,
    };
    if(isVFBlackUser){
      borderStyle = {
        border: '2px solid transparent',
        //this gradient is meant to look good with the gradients in the .star class
        //as well as the background wrapping our charString.
        background: `linear-gradient(#000000, #000000) padding-box, linear-gradient(135deg, #faeea0, #dda030, #9a5a1c) border-box`,
      }
    }

    let sharedStyles = {
      display: 'inline-flex',
      justifyContent: 'center',
      alignItems: 'center',

      wordBreak: 'keep-all',
      position: 'relative',
      pointerEvents: 'none',
      boxSizing: 'border-box',
      isolation: 'isolate',

      ...borderStyle,
    }

    let badgeStyle =  {
      fontSize: '22px',
      borderRadius: '6px',
      width: `${MEDIUM_SIZE_WIDTH}px`,
      height: `${MEDIUM_SIZE_WIDTH}px`,
      minWidth:`${MEDIUM_SIZE_WIDTH}px`,
      ...sharedStyles
    }
    if(small){
      badgeStyle = {
        fontSize: '10px',
        borderRadius: '3px',
        width: '26px',
        height: '26px',

        ...sharedStyles
      };
    }
    else if(large){
      badgeStyle = {
        fontSize: '30px',
        borderRadius: '6px',
        width: '70px',
        height: '70px',

        ...sharedStyles
      };
    }
    return badgeStyle;
  })

  getColorStyle = memoizeOne((userColor, overrideColor, isVFBlackUser) => {
    if(isVFBlackUser){
      return {}
    }

    let colorStyle = {backgroundColor : userColor};
    if(overrideColor){
      colorStyle = {backgroundColor : overrideColor}
    }
    return colorStyle;
  })

  getIsVFBlackUser = memoizeOne((guest_uid, userClassLookup, accountInfo) => {
    // log.log('getIsVFBlackUser', guest_uid, _.get(userClassLookup, `[${guest_uid}].logo_tag`), accountInfo);
    if(!guest_uid){
      return false;
    }
    if(guest_uid === _.get(accountInfo, 'uid')){
      return _.get(accountInfo, 'logo_tag') === c.ACCOUNT_LOGO_TYPES.BLACK;
    }

    return _.get(userClassLookup, `[${guest_uid}].logo_tag`) === c.ACCOUNT_LOGO_TYPES.BLACK
  })

  render(){
    let {
      small,
      large,
      overrideColor,
      guest,
      publisherInfo,
      userClassLookup,
      accountInfo
    } = this.props;

    let guest_uid = this.getGuestUid(guest);
    let isVFBlackUser = this.getIsVFBlackUser(guest_uid, userClassLookup, accountInfo);
    let badgeStyle = this.getBadgeStyle(small, large, isVFBlackUser);

    if(publisherInfo){
      let publisherColor = this.getUserColor(publisherInfo.title);
      return (
        <div style={{
               ...badgeStyle,
               ...{color: colors.LIGHT},
               ...{backgroundColor: publisherColor}
             }}>
          <i className="icon icomoon-newspaper enlarged-badge-font"/>
        </div>
      )
    }

    let userColor = this.getUserColor(guest_uid);
    let charString = this.getCharString(guest);
    let colorStyle = this.getColorStyle(userColor, overrideColor, isVFBlackUser);

    if(guest_uid) {
      return (
        <div style={{
          ...badgeStyle,
          ...{color: colors.LIGHT},
          ...colorStyle,
          zIndex: 1
        }}>
          {isVFBlackUser &&
            <div className={`star ${small ? 'small' : 'large'}`}/>
          }

          {isVFBlackUser &&
          <span style={{
            position: 'relative',
            zIndex: 1,
            background: 'linear-gradient(135deg, #faeea0, #dda030, #9a5a1c)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            backgroundClip: 'text',
          }}>
            {charString}
          </span>
          }
          {!isVFBlackUser && charString}

        </div>
      )
    }
    else{
      //No guest_uid, show special color and icon
      return (
        <div style={{
          ...badgeStyle,
          ...{color: colors.LIGHT},
          ...{backgroundColor : colors.SECONDARY_TEXT}}}>
          <i className="icon ion-android-person" />
        </div>
      )
    }
  }

}

UserBadge.propTypes = {
  guest : PropTypes.object.isRequired,
  publisherInfo : PropTypes.object,
  overrideColor : PropTypes.string,
  small : PropTypes.bool,
  large : PropTypes.bool
}

const mapStateToProps = (state) => {
  return {
    userClassLookup : state.shared.userClassLookup,
    accountInfo : state.shared.accountInfo
  }
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export { MEDIUM_SIZE_WIDTH };
export default withVfRouting(connect(mapStateToProps, mapDispatchToProps)(UserBadge));
